import { Adapter, IPagination } from "../../shared/types";
import { functionShared } from "../../shared/functions";

const { formatDate } = functionShared;

export interface ApprovalItem {
  approvalId: number;
  approvalType: string;
  approvalTypeId: number;
  approvalStatus: string;
  approvalStatusId: number;
  messageRequest: string;
  requestDate: string;
  updatedAt: string;
  updatedAtDetails?: string;
  folioIRVE?: string;
  address?: string;
  commune?: string;
  region?: string;
  chargersCount?: string;
  user: {
    businessDetailsId: number;
    name: string;
    rut: string;
    commune?: string;
    region?: string;
    address?: string;
  };
  userTarget: any;
  sec: any;
  location: any;
  fieldsRequest?: any;
  lastFieldsRequest?: any;
  hasTe6Changes?: boolean;
  hasElectricalChanges?: boolean;
}

interface ApprovalData {
  pagination: IPagination;
  items: ApprovalItem[];
}
export const approvalsAdapter: Adapter<ApprovalData> = (data) => {
  const {
    total_items: totalItems,
    total_pages: totalPages,
    current_page: currentPage,
    items_per_page: itemsPerPage,
  } = data;
  const pagination: IPagination = {
    totalItems,
    totalPages,
    currentPage,
    itemsPerPage,
  };

  const items: ApprovalItem[] = (data.items || []).map((item: any) => {
    const location = item?.location || {};
    const folio_IRVE = location.folio_IRVE ?? "";
    const address = location.address ?? "";
    const commune = location.commune ?? "";
    const region = location.region ?? "";

    // Parsear fields_request si viene como string
    const rawFieldsRequest = item?.fields_request;
    const fieldsRequest = typeof rawFieldsRequest === 'string'
      ? safeJsonParse(rawFieldsRequest)
      : (rawFieldsRequest ?? null);

    // Use backend-provided flags for reliable detection
    const hasTe6Changes = item?.has_te6_changes ?? false;
    const hasElectricalChanges = item?.has_electrical_changes ?? false;

    // Determine approval type based on backend flags
    let approvalType = item?.approval_type;
    if (hasTe6Changes && hasElectricalChanges) {
      approvalType = "CONFIRMACIÓN DE DATOS DE TE-6 y CONEXIÓN A RED ELÉCTRICA";
    } else if (hasElectricalChanges) {
      approvalType = "CONEXIÓN A RED ELÉCTRICA";
    }

    const user = item?.user || {};

    return {
      approvalId: item?.approval_id,
      approvalType: approvalType,
      approvalTypeId: item?.approval_type_id,
      approvalStatus: item?.approval_status,
      approvalStatusId: item?.approval_status_id,
      messageRequest: item?.message_request,
      requestDate: formatDate(item?.request_date || ''),
      updatedAt: formatDate(item?.updated_at || ''),
      updatedAtDetails: item?.updated_at,
      folioIRVE: folio_IRVE,
      address,
      commune,
      region,
      chargersCount: (item?.number_of_evses ?? 0) + '',
      user: {
        businessDetailsId: user.business_details_id,
        name: user.name,
        rut: user?.RUT,
        commune: user?.commune,
        region: user?.region,
        address: user?.address,
      },
      userTarget: item?.user_target || null,
      sec: item?.sec || null,
      location: item?.location || null,
      fieldsRequest: fieldsRequest,
      lastFieldsRequest: item?.last_fields_request ?? null,
      hasTe6Changes,
      hasElectricalChanges,

    } as any;
  });

  function safeJsonParse(text: string) {
    try {
      return JSON.parse(text);
    } catch {
      return null;
    }
  }

  return { pagination, items };
};
